import { Box, Link, Heading } from "@ogt/ui";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { URLS } from "src/config/urls";

export default function SubscriptionCancelled() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();

  return (
    <Box fullwidth>
      <Heading className="h2" headingRef={h2Ref} id="thankYouHeading" focusable>
        Du är nu avregistrerad
      </Heading>
      <div role="group">
        <p>
          Vad tråkigt att du inte längre är med på resan. Nu får du inte längre
          våra nyhetsbrev.
        </p>
        <p>
          Men du ska veta att vi redan saknar dig. Och om du framöver vill hoppa
          på tåget igen, kan du anmäla dig till nyhetsbrev via Mitt konto.
        </p>
        <Link
          format="default"
          icon="arrow-right"
          iconPosition="right"
          size="base"
          underline="always"
          variant="default"
          href={URLS.advantageMyAccount}
        >
          Fördelar med Mitt konto
        </Link>
      </div>
    </Box>
  );
}
